$(document).on('turbo:load', () => {
  if (typeof $(document).foundation !== 'function') {
    Foundation.addToJquery($);
  }

  $(document).foundation();
});
